module.exports = __webpack_public_path__ + "44b3cdd15a4c20a1c8ffb0a45301ed5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1/public/team/Leadership_Curtis_0.jpg
// module id = 448
// module chunks = 0